import 'slick/slick.min.js';
import 'acf-maps.js';
import 'glightbox/glightbox.js';

(function($) {

   // Smooth scroll
   var $root = $('html, body'); // cache

   $('a[href^="#"]').click(function () {

     $root.animate({
       scrollTop: $( $.attr(this, 'href') ).offset().top - 95 // header height
     }, 500);
     return false;
   });

  /* Toggle nav */
	$(document).on('click', '.-js-navModal-toggle', function() {
		$(this).toggleClass('-open');
		$('body').toggleClass('-navModal-open');
		$('.-js-navModal').toggleClass('-collapsed');
		var isOpen = $(this).hasClass('-open');
		$(this).attr('aria-label', isOpen ? 'Sluit menu' : 'Open menu');
	});

	/* Slick carousel */
	var $carousel = $('.-js-carousel');

	var carousel_settings = {
		slidesToShow: 1,
		sldesToScroll: 1,
		arrows: true,
		waitForAnimate: true,
		swipe: true,
		touchMove: true,
		accessibility: true,
		nextArrow: '<button class="carousel__arrow -next" aria-label="Verder scrollen in carousel"></button>',
		prevArrow: '<button class="carousel__arrow -previous" aria-label="Terug scrollen in carousel"></button>',
		infinite: true,
		mobileFirst: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					centerMode: false,
				},
			},
			{
				breakpoint: 830,
				settings: {
					slidesToShow: 4,
					centerMode: false,
				},
			},
		],
	};

	// Init
	$carousel.slick(carousel_settings);

	/* Slick USP */
	var $usp_carousel = $('.-js-homeUsp-carousel');
	var usp_carousel_settings = {
		slidesToShow: 1,
		sldesToScroll: 1,
		arrows: false,
		waitForAnimate: false,
		swipe: true,
		touchMove: true,
		accessibility: false,
		infinite: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 99999,
				settings: 'unslick',
			},
			{
				breakpoint: 952,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 840,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	// Init
	$usp_carousel.slick(usp_carousel_settings);

	// Reslick only if it's not slick()
	$(window).on('resize', function() {
		if (!$usp_carousel.hasClass('slick-initialized')) {
			return $usp_carousel.slick(usp_carousel_settings);
		}
	});

	// FAQ
	$(document).on('click', '.js-faq-item:not(.-active) .js-faq-question', function() {
		$('.js-faq-item.-active')
			.removeClass('-active')
			.find('.js-faq-answer')
			.slideUp(250);
		$(this)
			.parent()
			.parent()
			.addClass('-active')
			.find('.js-faq-answer')
			.slideDown(250);
	});

	$('.js-mobile-nav .menu-item.menu-item-has-children').each(function() {
		$(this)
			.find('> a')
			.after('<button class="sub-menu-toggle js-submenu-toggle" aria-label="Open submenu"></button>');
		$(this)
			.find('.sub-menu')
			.data('inner-tabindex', '-1')
			.find('a')
			.attr('tabindex', '-1');
	});

	// Mobile menu
	$(document).on('click', '.js-mobile-nav .js-submenu-toggle', function(e) {
		e.preventDefault();
		$(this)
			.parent()
			.toggleClass('-active');
		var submenu = $(this)
			.parent()
			.find('.sub-menu');
		$(this).attr('aria-label', submenu.data('inner-tabindex') === '-1' ? 'Sluit submenu' : 'Open submenu');
		submenu.find('a').attr('tabindex', submenu.data('inner-tabindex') === '-1' ? '0' : '-1');
		submenu.data('inner-tabindex', submenu.data('inner-tabindex') === '-1' ? '0' : '-1');
	});

	// Tabnav submenu
	$('.menu-item.menu-item-has-children').on('focusin', function() {
		$(this).addClass('is-focused');
	});

	var focusOutTimer;
	$('.menu-item.menu-item-has-children').on('focusout', function() {
		clearTimeout(focusOutTimer);
		var el = $(this);

		focusOutTimer = setTimeout(function() {
			if (el.has(document.activeElement).length == 0) {
				el.removeClass('is-focused');
			}
		}, 100);
	});

	// Fade in sections when scrolled in view
	var elements;
	var windowHeight;

	function sectionAnimateInit() {
		elements = document.querySelectorAll('.js-fade-in.-hidden');
		windowHeight = window.innerHeight;
	}

	function sectionAnimateCheckPosition() {
		for (var i = 0; i < elements.length; i++) {
			var element = elements[i];
			var positionFromTop = elements[i].getBoundingClientRect().top;

			if (positionFromTop - windowHeight <= 0) {
				element.classList.add('-fade-in-section');
				element.classList.remove('-hidden');
			}
		}
	}

	window.addEventListener('scroll', sectionAnimateCheckPosition);
	window.addEventListener('resize', sectionAnimateInit);

	sectionAnimateInit();
	sectionAnimateCheckPosition();

	// Accordions
	$(document).on('click', '.js-item-button:not(.-active)', function() {
		var content = $(this)
			.next()
			.html();

		$('.js-item-button.-active')
			.not(this)
			.removeClass('-active');

		$(this)
			.addClass('-active')
			.parents('section')
			.find('.js-item-content div')
			.fadeOut(250, function() {
				$(this)
					.html(content)
					.fadeIn(250);
			});
	});

})(jQuery);
